import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MetadataService {
    constructor() {}

    getSessionId(): string {
        return sessionStorage.getItem('sessionID');
    }

    getSolvId(): string | null {
        return (
            JSON.parse(sessionStorage.getItem('sellerDetails'))?.solvId || null
        );
    }

    getEid(): string | null {
        return (
            JSON.parse(sessionStorage.getItem('sellerDetails'))?.smeId || null
        );
    }

    getDeviceType(): string {
        const width = window.innerWidth;
        if (width <= 767) return 'mobile';
        if (width <= 1024) return 'tablet';
        return 'desktop';
    }

    getOSInfo(): { os: string; browser: string; version: string } {
        const ua = navigator.userAgent;
        let os = 'Unknown',
            browser = 'Unknown',
            version = 'Unknown';

        if (/Windows NT/.test(ua)) os = 'Windows';
        else if (/Mac OS X/.test(ua)) os = 'macOS';
        else if (/Android/.test(ua)) os = 'Android';
        else if (/iPhone|iPad/.test(ua)) os = 'iOS';

        if (/Chrome/.test(ua)) {
            browser = 'Chrome';
            version = ua.match(/Chrome\/([\d.]+)/)?.[1] || 'Unknown';
        } else if (/Firefox/.test(ua)) {
            browser = 'Firefox';
            version = ua.match(/Firefox\/([\d.]+)/)?.[1] || 'Unknown';
        } else if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
            browser = 'Safari';
            version = ua.match(/Version\/([\d.]+)/)?.[1] || 'Unknown';
        }

        return { os, browser, version };
    }
}
